const GridIcons = {
  "column-icon": `<div class="column"><svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 18.5H8.5V18L8.5 6V5.5H8L4 5.5H3.5V6L3.5 18V18.5H4H8ZM14 18.5H14.5V18L14.5 6V5.5H14L10 5.5H9.5V6L9.5 18V18.5H10H14ZM20 18.5H20.5V18V6V5.5H20H16H15.5V6L15.5 18V18.5H16H20ZM4 4.5L20 4.5C20.3978 4.5 20.7794 4.65804 21.0607 4.93934C21.342 5.22064 21.5 5.60218 21.5 6V18C21.5 18.3978 21.342 18.7794 21.0607 19.0607C20.7794 19.342 20.3978 19.5 20 19.5H4C3.60218 19.5 3.22064 19.342 2.93934 19.0607C2.65804 18.7794 2.5 18.3978 2.5 18L2.5 6C2.5 5.60218 2.65804 5.22064 2.93934 4.93934C3.22064 4.65804 3.60218 4.5 4 4.5Z"
      stroke="#706B69"
    />
  </svg></div>`,
  "setting-icon": '<owc-icon name="settings" type="legacy" />',
};
export default GridIcons;
